import React from "react";
import { colors2, UI_BODY_SM, UI_BODY_SEMIBOLD_SM } from "oolib";
import { ButtonTertiaryCompact } from "oolib/dist/v2/components/Buttons";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";
import { formatDate } from "../IntegrationSettingsModal";
import { Card, CardHeader, Row, Actions, redOutline } from "./styled";

/**
 * "Connection active" card at the top of a manage popup: Disconnect, then the
 * account, who authorised it and since when. conn is the status response.
 * Disconnect shows only with canDelete.
 */
export const ConnectionDetailsCard = ({ conn, canDelete, onDisconnect }) => (
  <Card>
    <CardHeader>
      <Actions style={{ gap: 6 }}>
        <DisplayIcon icon="CheckCircle" size={18} color={colors2.green} />
        <UI_BODY_SEMIBOLD_SM style={{ color: colors2.greenText }}>
          Connection active
        </UI_BODY_SEMIBOLD_SM>
      </Actions>
      {canDelete && (
        <ButtonTertiaryCompact
          icon="X"
          iconColor={colors2.red}
          style={redOutline}
          onClick={onDisconnect}
        >
          Disconnect
        </ButtonTertiaryCompact>
      )}
    </CardHeader>
    {[
      ["Account", conn?.providerAccountName],
      [
        "Authorized by",
        conn?.authorizedBy?.name
          ? `${conn.authorizedBy.name} (${conn.adminEmail})`
          : conn?.adminEmail,
      ],
      ["Connected since", formatDate(conn?.connectedAt)],
    ].map(([label, value]) => (
      <Row key={label}>
        <UI_BODY_SM style={{ color: colors2.grey60 }}>{label}</UI_BODY_SM>
        <UI_BODY_SM>{value || "—"}</UI_BODY_SM>
      </Row>
    ))}
  </Card>
);

export default ConnectionDetailsCard;
